import script from "./simple-datepicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./simple-datepicker.vue?vue&type=script&lang=ts&setup=true"

import "./simple-datepicker.vue?vue&type=style&index=0&id=5b1e449e&lang=scss&scoped=true"
import "./simple-datepicker.vue?vue&type=style&index=1&id=5b1e449e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b1e449e"]])

export default __exports__